export class BaseEvent  {
  public readonly eventType: string = (<object>this).constructor.name;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/events/BaseEvent.ts